module.exports = __webpack_public_path__ + "img/felc-92赛区.89a17f45.png";